import { createAction, props } from '@ngrx/store';
import {Credentials} from '../../interfaces/credentials';
import {GoogleErrorResponse} from '../../../shared/interfaces/google-error-response';
import {AuthResponse} from '../../../shared/interfaces/auth-response';

export const Login = createAction(
  '[Login Page] Login',
  props<{ credentials: Credentials }>()
);
export const LoginSuccess = createAction(
  '[Login Page] Login Success',
  props<{ response: AuthResponse }>()
);
export const LoginFailure = createAction(
  '[Auth API] Login Failure',
  props<{ error: any }>()
);
export const CheckLogin = createAction('[Auth] Check Login');
export const Logout = createAction('[Auth] Confirm Logout');
export const LogoutCancelled = createAction('[Auth] Logout Cancelled');
export const LogoutConfirmed = createAction('[Auth] Logout Confirmed');
export const GoogleLogin = createAction('[Login Page] Google Login');
export const GoogleLoginSuccess = createAction(
  '[Google Auth] Login Success',
  props<{token: string}>()
);
export const GoogleLoginFailure = createAction(
  '[Google Auth] Login Failure',
  props<GoogleErrorResponse>()
);

